import React from 'react';
import connect from 'react-redux/es/connect/connect';
import axInst from '../_helpers/axios-instance';
import config from '../_services/config';

class Auth extends React.Component {
  componentDidMount() {
    axInst.defaults.headers.common['Authorization'] = this.props.loggedIn && this.props.token
      ? `Token ${this.props.token}`
      : `Token ${config.guestToken}`;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // Привязываем изменение ключа в state к axInst
    if (
      this.props.token === undefined
    ) {
      axInst.defaults.headers.common['Authorization'] = `Token ${config.guestToken}`;
    } else
      if (
      this.props.token !== prevProps.token
    ) {
      axInst.defaults.headers.common['Authorization'] = `Token ${this.props.token}`;
    }
  }

  render() {
    return <React.Fragment/>;
  }
}

function mapState(state) {
  const {authentication} = state;
  const {key: token, loggedIn} = authentication;
  return {token, loggedIn};
}

const actionCreators = {
  // getUserBalance: userActions.getUserBalance,
};

export default connect(mapState, actionCreators)(Auth);
